module.exports = __webpack_public_path__ + "static/income_statement_1-e72515e060ace9fb22376e98a58ad3f5.jpg";